export * from './app-sidebar-header.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/components/app-sidebar-header/index.ts